import { lazy, StrictMode, Suspense } from 'react';
import { render } from 'react-dom';
import createSdk, { addInjectionPoints } from 'apps/widget/sdk';
import { WidgetConfiguration } from 'types';
import {
  injectWidgets as injectWidgetsUtil,
  getInjectionPoints,
} from 'utils/injection';

// NB: It's important this this is a lazy import.  If not lazy, all of the styles
// associated with the component tree will be injected at import time, which is
// before the shadow dom gets created below.  Since styles have to be injected into
// the shadow dom (see webpack config), we have to ensure shadow dom exists before
// importing any styles
const App = lazy(() => import('./App'));

async function injectWidgets(
  elementOrSelector?: string | HTMLElement,
  config?: Partial<WidgetConfiguration>,
) {
  const slots = getInjectionPoints(elementOrSelector);
  addInjectionPoints(window.disco, slots);

  injectWidgetsUtil(
    slots,
    ({
      clientIp,
      engagementTrackingUrl,
      root,
      sessionId,
      title,
      url,
      bundleId,
      variantId,
      widgetId,
    }) =>
      render(
        <StrictMode>
          <Suspense fallback={null}>
            <App
              reactRoot={root}
              {...{
                clientIp,
                engagementTrackingUrl,
                sessionId,
                title,
                url,
                bundleId,
                variantId,
                widgetId,
              }}
            />
          </Suspense>
        </StrictMode>,
        root,
      ),
    config,
  );
}

window.disco = createSdk(injectWidgets);

async function initialize() {
  injectWidgets();
}

initialize();
